import { Button, ButtonProps, forwardRef } from "@chakra-ui/react";
import React from "react";
import colors from "app/colors";

const LeftNavCallInvitesActionButton = forwardRef<ButtonProps, "button">(
  ({ children, ...rest }, ref) => (
    <Button
      ref={ref}
      variant="hover"
      bg={colors.orangePrimary}
      size="xs"
      fontSize={10}
      fontWeight={600}
      color={colors.white}
      px={3}
      py={1}
      borderRadius={4}
      flexShrink={0}
      {...rest}
    >
      {children}
    </Button>
  ),
);

LeftNavCallInvitesActionButton.displayName = "LeftNavCallInvitesActionButton";

export default LeftNavCallInvitesActionButton;
